export default __webpack_public_path__ + "static/media/img66.83f88bbd.jpg";